<ng-container *transloco="let t; prefix: 'services_page'">
  <div
    class="hidden font-semibold text-xs text-neutral-500 md:flex gap-x-1 items-center"
  >
    <button
      routerLink="/home"
      class="btn btn-link p-0 no-underline text-neutral-500"
    >
      <span>Home</span>
    </button>
    <i class="fa-solid fa-chevron-right"></i>
    <button class="btn btn-link p-0 no-underline text-neutral-500">
      <span>Services</span>
    </button>
  </div>

  <h1 class="font-extrabold text-4xl">{{ t("title") }}</h1>
  <p>{{ t("subtitle") }}</p>

  <!-- <div class="flex mt-5 w-full">
    <div
      role="tablist"
      class="tabs tabs-boxed flex shadow font-semibold bg-white dark:bg-base-100 rounded-box p-2 w-full"
    >
      <a role="tab" class="tab flex-1 rounded-box tab-active">Payment</a>
      <a role="tab" class="tab flex-1 rounded-box">Airtime and Data</a>
      <a role="tab" class="tab flex-1 rounded-box">Bills and Utilities</a>
    </div>
  </div> -->

  <div class="flex flex-col gap-y-2 mt-5">
    <div class="collapse collapse-arrow bg-white dark:bg-base-100">
      <input type="checkbox" name="services" checked />
      <div class="collapse-title font-normal">Payment</div>
      <div class="collapse-content bg-base-200 px-2 !py-0">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 my-4 !pt-2">
          <button
            (click)="requestPayment()"
            class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-paper-plane text-3xl"></i>
            <span class="text-sm" *transloco="let t; prefix: 'services'">{{
              t("send_money")
            }}</span>
          </button>
          <button
            (click)="requestPayment()"
            class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-comments-dollar text-3xl"></i>
            <span class="text-sm" *transloco="let t; prefix: 'services'">{{
              t("request_money")
            }}</span>
          </button>
          <button
            (click)="requestPayment()"
            class="btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex justify-between md:flex-col md:justify-center items-center size-auto gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary col-span-full md:col-span-1"
          >
            <span
              class="flex md:flex-col items-center md:justify-between gap-2 h-full"
            >
              <i
                class="fa-solid fa-money-bill-transfer text-lg md:text-3xl"
              ></i>
              <span class="text-sm" *transloco="let t; prefix: 'services'">{{
                t("momo_to_bank")
              }}</span>
            </span>
            <i class="fa-solid fa-chevron-right text-md md:hidden flex"></i>
          </button>
          <button
            (click)="requestPayment()"
            class="btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex justify-between md:flex-col md:justify-center items-center size-auto gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary col-span-full md:col-span-1"
          >
            <span
              class="flex md:flex-col items-center md:justify-between gap-2 h-full"
            >
              <i
                class="fa-solid fa-print-magnifying-glass text-xl md:text-3xl"
              ></i>
              <span class="text-sm" *transloco="let t; prefix: 'services'">{{
                t("check_balance")
              }}</span>
            </span>
            <i class="fa-solid fa-chevron-right text-md md:hidden flex"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="collapse collapse-arrow bg-white dark:bg-base-100">
      <input type="checkbox" name="payments" checked />
      <div
        class="collapse-title font-normal"
        *transloco="let t; prefix: 'services'"
      >
        {{ t("airtime_and_data") }}
      </div>
      <div class="collapse-content bg-base-200 px-2 !py-0">
        <div class="grid grid-cols-3 md:grid-cols-4 gap-2 md:gap-6 mb-4 !pt-2">
          <button
            class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-phone-volume text-2xl md:text-3xl"></i>
            <span
              class="text-xs md:text-sm"
              *transloco="let t; prefix: 'services'"
              >{{ t("airtime") }}</span
            >
          </button>
          <button
            class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-wifi text-2xl md:text-3xl"></i>
            <span
              class="text-xs md:text-sm"
              *transloco="let t; prefix: 'services'"
              >{{ t("internet") }}</span
            >
          </button>
        </div>
      </div>
    </div>
    <div class="collapse collapse-arrow bg-white dark:bg-base-100">
      <input type="checkbox" name="payments" checked />
      <div
        class="collapse-title font-normal"
        *transloco="let t; prefix: 'services'"
      >
        {{ t("bills_and_utilities") }}
      </div>
      <div class="collapse-content bg-base-200 px-2 !py-0">
        <div class="grid grid-cols-3 md:grid-cols-4 gap-2 md:gap-6 mb-4 !pt-2">
          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <!-- <i class="fa-solid fa-circle-plus text-2xl md:text-3xl"></i> -->
            <img
              class="hidden dark:flex"
              src="./assets/icons/services/canalbox-light.svg"
              alt=""
            />
            <img
              class="dark:hidden"
              src="./assets/icons/services/canalbox-dark.svg"
              alt=""
            />
            <span
              class="text-xs md:text-sm"
              *transloco="let t; prefix: 'services'"
              >{{ t("canalbox") }}</span
            >
          </button>
          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-plug-circle-bolt text-2xl md:text-3xl"></i>
            <span
              class="text-xs md:text-sm"
              *transloco="let t; prefix: 'services'"
              >{{ t("electricity") }}</span
            >
          </button>
          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:bg-primary hover:text-white dark:hover:bg-primary"
          >
            <i class="fa-solid fa-droplet text-2xl md:text-3xl"></i>
            <span
              class="text-xs md:text-sm"
              *transloco="let t; prefix: 'services'"
              >{{ t("water") }}</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="mt-5 mb-2">
    <h3 class="text-xs md:text-base uppercase">Payment</h3>
  </div>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Send Money</span>
    </button>
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Request Payment</span>
    </button>
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Check Balance</span>
    </button>
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">MoMo to Bank</span>
    </button>
  </div>
  
  <div class="mt-5 mb-2">
    <h3 class="text-xs md:text-base uppercase">Airtime and Data</h3>
  </div>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Buy Airtime</span>
    </button>
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Buy Data</span>
    </button>
  </div>
  
  <div class="mt-5 mb-2">
    <h3 class="text-xs md:text-base uppercase">Bills and Utilities</h3>
  </div>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Renew CanalBox</span>
    </button>
    <button
      class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
    >
      <i class="fa-solid fa-circle-plus text-4xl"></i>
      <span class="text-sm">Pay Bills</span>
    </button>
  </div> -->

  <qwiko-all-services></qwiko-all-services>
</ng-container>
